
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_4b8im_145",
  "pad-bottom": "awsui_pad-bottom_15o6u_4b8im_167",
  "virtual": "awsui_virtual_15o6u_4b8im_171",
  "has-background": "awsui_has-background_15o6u_4b8im_174",
  "highlighted": "awsui_highlighted_15o6u_4b8im_177",
  "selected": "awsui_selected_15o6u_4b8im_177",
  "disabled": "awsui_disabled_15o6u_4b8im_195",
  "next-item-selected": "awsui_next-item-selected_15o6u_4b8im_205",
  "is-keyboard": "awsui_is-keyboard_15o6u_4b8im_217",
  "visual-refresh": "awsui_visual-refresh_15o6u_4b8im_220",
  "parent": "awsui_parent_15o6u_4b8im_223",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_4b8im_227",
  "child": "awsui_child_15o6u_4b8im_243",
  "sticky": "awsui_sticky_15o6u_4b8im_249",
  "with-scrollbar": "awsui_with-scrollbar_15o6u_4b8im_261",
  "after-header": "awsui_after-header_15o6u_4b8im_267",
  "measure-strut": "awsui_measure-strut_15o6u_4b8im_302",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_4b8im_311",
  "screenreader-content": "awsui_screenreader-content_15o6u_4b8im_315",
  "option-content": "awsui_option-content_15o6u_4b8im_321",
  "select-all": "awsui_select-all_15o6u_4b8im_325"
};
  